import { isVisible } from "@testing-library/user-event/dist/utils";
import { useState, useEffect } from "react";

export default function Content() {
    useEffect(() => {
        console.log("useEffect");
    }, []);

    const [visible, setVisible] = useState(false);

    const chatScenarios = [
        { id: 0, name: 'Bagaimana Cara Mengajukan Pinjaman?', profession: 'mathematician' },
        { id: 1, name: 'Berapa Jumlah Minimum dan Maksimum Pengajuan Pinjaman?', profession: 'chemist' },
        { id: 2, name: 'Status pengajuan pinjaman saya bagaimana ?', profession: 'physicist' },
        { id: 3, name: 'Berapa nominal kalau mau mendanai', profession: 'chemist' },
        { id: 4, name: 'Apakah ada biaya untuk menjadi Pemberi Pinjaman', profession: 'astrophysicist' }
    ];

    const chatLenght = chatScenarios.length;

    function onClicked() {
        if (visible == true) setVisible(true);
        else setVisible(false);
    };

    const chemists = chatScenarios.filter(chatScenario =>
        chatScenario.profession === 'chemist'
    );

    const listItems = chemists.map(chatScenario =>
        <>
            <button className='accordion' onClick={onClicked}>{chatScenario.name}</button>
            <div id={chatScenario.id} className="accordion-panel" style={visible == true ? { display: 'contents' } : { display: 'none' }}>
                <p>{chatScenario.profession}</p>
            </div>
        </>
    );

    return (
        <>
            <div class="breadcrumb-wrapper-kkb-detail" id="lihatSemua">
                <div class="general-container">
                    <header>
                        <div class="ui-g-12">
                            <h4 class="h4-faq-terpopuler">Topik Populer</h4>

                            <ul class="breadcrumb">
                                <li><a href="landing-page.xhtml">Home</a></li>
                                <li class="final">FAQ</li>
                            </ul>
                        </div>
                    </header>
                </div>
            </div>

            <article class="kkb-of-loans" >
                <div class="general-container">
                    <div class="ui-g padding-accordion" >
                        <div class="ui-g-12" >
                            {listItems}
                        </div>
                    </div>
                </div>
            </article>

        </>
    );
}

